var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 25V15H11.8246L15.9014 21.5286H14.4163L18.3766 15H21.2012L21.2303 25H18.0999L18.0708 19.6285H18.5658L15.8577 24.1H14.3434L11.5188 19.6285H12.1303V25H9ZM22.4487 25V15H27.3554C28.3067 15 29.1293 15.1524 29.8233 15.4571C30.5173 15.7619 31.0536 16.1976 31.4322 16.7643C31.8108 17.331 32 18 32 18.7714C32 19.5429 31.8108 20.2095 31.4322 20.7714C31.0536 21.3333 30.5173 21.769 29.8233 22.0786C29.1293 22.3881 28.3067 22.5428 27.3554 22.5428H24.3561L25.8849 21.1V25H22.4487ZM25.8849 21.4715L24.3561 19.9429H27.137C27.6126 19.9429 27.9645 19.8381 28.1926 19.6286C28.4207 19.4191 28.5347 19.1334 28.5347 18.7715C28.5347 18.4096 28.4206 18.1239 28.1926 17.9143C27.9645 17.7048 27.6126 17.6001 27.137 17.6001H24.3561L25.8849 16.0715V21.4715Z",
    fill: "#AEC6E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu-2.122069d8c875112977c849d7407caf17.svg";
export { ForwardRef as ReactComponent };